export { default } from "./extractEventHandlers.mjs";